import React, { useEffect, useRef, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";

const useStyles = makeStyles(() => ({
  root: {
    display: "flex",
    flexDirection: "column",
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    overflowX: "hidden",
  },
  header: {},
  container: { height: "calc(100% - 220px)" }, // subtracting header n footer height
  visualization: {
    height: "100%",
    display: "flex",
    marginLeft: 20,
  },
}));

const DefaultLayout = ({
  width,
  renderHeader,
  renderVisualization,
  renderSettings,
  renderSaveConfiguration,
  renderSendEmail,
  renderPdfDownload,
  renderLoadConfiguration,
  renderAddToCart,
  ...props
}) => {
  const classes = useStyles(props);

  return (
    <div className={`${classes.root}`}>
      <div className={classes.header}>
        {renderHeader({
          width,
          classes,
        })}
      </div>
      <div>{renderSettings()}</div>
      {renderSaveConfiguration()}
      {renderSendEmail()}
      {renderPdfDownload()}
      {renderLoadConfiguration()}
      <div className={`${classes.container}`}>
        {<div className={classes.visualization}>{renderVisualization()}</div>}
      </div>
      {renderAddToCart()}
    </div>
  );
};

DefaultLayout.propTypes = {
  classes: PropTypes.object,
  width: PropTypes.string,
  renderHeader: PropTypes.func,
  renderVisualization: PropTypes.func,
  renderSettings: PropTypes.func,
};

export default DefaultLayout;
